import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '../_services/api.service';
import { ProgressTrackerService } from '../_services/progress-tracker.service';

@Component({
    selector: 'true-assessment-selector',
    templateUrl: './assessment-selector.component.html',
    styleUrls: ['./assessment-selector.component.scss'],
    standalone: false
})
export class AssessmentSelectorComponent implements OnInit {
  public assessments = [];
  public objects = null;
  public objectId = null;
  public assessmentId = null;
  public productInfo: string = ''

  public state = 'list';
  public name = '';

  public simple = false;

  @Output() done = new EventEmitter();

  constructor(private api: ApiService, private dialogRef: MatDialogRef<AssessmentSelectorComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private progressTracker: ProgressTrackerService) {
    if (this.data) {
      if (this.data.simple) {
        this.simple = true;
      }

      if (this.data.newAssessment) {
        this.create();
      }
    }
  }

  ngOnInit(): void {
    this.api.getAssessmentObjects().subscribe(objects => {      
      this.objects = objects;
      if (objects.length > 0) {
        this.objectId = objects[0].id;
      }
    });
    this.api.getAssessments().subscribe(assessments => {      
      this.assessments = assessments;
    });
  }

  create() {
    this.assessmentId = null;
    this.name = '';
    this.state = 'create';
    this.progressTracker.initialize();

  }

  importDemo() {
    this.api.importDefaultAssessment().subscribe(      
      (assessment: any) => {        
        this.assessments.push(assessment);
        this.assessmentId = assessment.id;
        this.api.setAssessment(assessment.id, assessment.name, assessment.Assessment_object.name, assessment.nodes);
        this.dialogRef.close();
        window.location.reload();
      }, (err) => {
        console.error('Error importing demo assessment:', err);
        alert('An error occurred while importing. Please try again later.');
      }
    );
  }

  load() {
    let assessment = this.assessments.find(a => a.id==this.assessmentId);    
    this.api.setAssessment(this.assessmentId, assessment.name, assessment.Assessment_object.name, assessment.nodes);    
    this.close();
    this.progressTracker.initialize();
  }

  close() {
    this.dialogRef.close();
  }

  delete() {
    this.api.removeAssessment(this.assessmentId).subscribe(() => {
      this.refresh();
    });
    this.refresh();
  }

  edit() {
    let assessment = this.assessments.find(a => a.id == this.assessmentId);
    this.name = assessment.name;    
    this.productInfo = assessment.productInfo;
    this.state = 'edit';
  }
  
  cancel() {
    this.state = 'list';
  }

  update() {    
    var observable;
    if (this.assessmentId == null) {
      observable = this.api.createAssessment(this.name, this.objectId, this.productInfo);
    } else {
      observable = this.api.updateAssessment(this.assessmentId, this.name, null, this.productInfo);
    }
    observable.subscribe((assessment) => {            
      if (!assessment.nodes) {
        // enabling all nodes for new assessments (TODO: move to better position)
        assessment.nodes =
        [
          {
              "key": "RadiantProduction",
              "enabled": true
          },
          {
              "key": "RadiantProcessing",
              "enabled": true
          },
          {
              "key": "RadiantTransportAndDistribution",
              "enabled": true
          },
          {
              "key": "RadiantMarketAndRetailers",
              "enabled": true
          }
        ];
      }
      if (!assessment.Assessment_object) {          
        this.api.setAssessment(assessment.id, assessment.name, this.objects[this.objectId-1].name, assessment.nodes);

      } else {          
        this.api.setAssessment(assessment.id, assessment.name, assessment.Assessment_object.name, assessment.nodes);
      }
      this.refresh();
      this.close();
      
    });
  }

  refresh() {    
    this.api.getAssessments().subscribe(assessments => {
      this.assessments = assessments;      
      this.state = 'list';
    });
  }
}
